import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import useTranslation from 'app/lib/hooks/useTranslation'

import ReportForm from './ReportForm'
import { IncidentSubject } from './typing'

export const useReportIncident = () => {
  const { t } = useTranslation()
  const { drawerfy } = useFeedbacker()

  return (subject?: IncidentSubject) =>
    drawerfy.open({
      title: t({ id: 'record.incident.report.title' }),
      drawerKey: 'report-incident',
      width: 500,
      singleDrawer: true,
      content: <ReportForm subject={subject} onSuccess={() => drawerfy.closeAll()} />
    })
}
